export default "__VITE_ASSET__DnivEwUv__"